function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import { Checkbox, FormControlLabel, FormGroup, InputAdornment, OutlinedInput } from "@mui/material";
import AiOutlineSearch from "@meronex/icons/ai/AiOutlineSearch";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CityList = function CityList(_ref) {
  var _config$projects;
  var _ref$cities = _ref.cities,
    cities = _ref$cities === void 0 ? [] : _ref$cities,
    cityUpdate = _ref.cityUpdate,
    _ref$projectCityList = _ref.projectCityList,
    projectCityList = _ref$projectCityList === void 0 ? [] : _ref$projectCityList,
    config = _ref.config;
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    name = _useState2[0],
    setName = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    foundUsers = _useState4[0],
    setFoundUsers = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    cityNames = _useState6[0],
    setCityNames = _useState6[1];
  useEffect(function () {
    var citys = projectCityList.map(function (city) {
      return {
        name: city,
        checked: cities.includes(city)
      };
    });
    setCityNames(_toConsumableArray(citys));
    setFoundUsers(_toConsumableArray(citys));
  }, [projectCityList]);
  var filter = function filter(e) {
    var keyword = e.target.value;
    if (keyword !== "") {
      var results = cityNames.filter(function (user) {
        return user.name.toLowerCase().startsWith(keyword.toLowerCase());
      });
      setFoundUsers(results);
    } else {
      setFoundUsers(cityNames);
    }
    setName(keyword);
  };
  var handleChange = function handleChange(event, city, index) {
    var list = cityNames;
    if (name === "") {
      city.checked = event.target.checked;
      list[index] = city;
      setCityNames(_toConsumableArray(list));
      setFoundUsers(_toConsumableArray(list));
    } else {
      var cindex = cityNames.indexOf(city);
      city.checked = event.target.checked;
      list[cindex] = city;
      setCityNames(_toConsumableArray(list));
      var newFound = foundUsers;
      newFound[index] = city;
      setFoundUsers(_toConsumableArray(newFound));
    }
  };
  useEffect(function () {
    cityUpdate(cityNames);
  }, [cityNames]);
  return /*#__PURE__*/_jsxs("div", {
    className: "text-base-content",
    children: [/*#__PURE__*/_jsx(OutlinedInput, {
      fullWidth: true,
      sx: {
        py: 0,
        height: "36px",
        marginBottom: 1,
        fontSize: 14,
        color: config !== null && config !== void 0 && config.darkMode ? "#ffffff" : "#000000",
        borderColor: config !== null && config !== void 0 && config.darkMode ? "#9b9b9b" : "#000000",
        borderStyle: "solid",
        borderWidth: "1px",
        "&:hover": {
          borderColor: config !== null && config !== void 0 && config.darkMode ? "#ffffff" : "#000000"
        },
        "&.Mui-focused": {
          borderColor: config !== null && config !== void 0 && config.darkMode ? "#9b9b9b" : "#9b9b9b"
        },
        "& fieldset": {
          borderRadius: "4px"
        }
      },
      id: "outlined-adornment-weight",
      value: name,
      onChange: filter,
      placeholder: "Search locations...",
      endAdornment: /*#__PURE__*/_jsx(InputAdornment, {
        position: "end",
        children: /*#__PURE__*/_jsx(AiOutlineSearch, {})
      }),
      "aria-describedby": "outlined-weight-helper-text",
      inputProps: {
        "aria-label": "weight"
      }
    }), /*#__PURE__*/_jsx("div", {
      className: "h-24 overflow-y-scroll scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-300 overflow-hidden mt-2",
      children: foundUsers && foundUsers.length > 0 ? /*#__PURE__*/_jsx(FormGroup, {
        component: "fieldset",
        variant: "standard",
        children: foundUsers.map(function (user, index) {
          return /*#__PURE__*/_jsx(FormControlLabel, {
            sx: {
              padding: 0,
              margin: 0,
              display: "block"
            },
            onChange: function onChange(event) {
              return handleChange(event, user, index);
            },
            control: /*#__PURE__*/_jsx(Checkbox, {
              sx: {
                padding: "4px 4px 4px 0px",
                color: "gray",
                margin: 0,
                "&.Mui-checked": {
                  color: config === null || config === void 0 ? void 0 : config.primaryColor
                }
              },
              checked: user.checked,
              value: user.name
            }),
            label: user.name
          }, user.name);
        })
      }) : /*#__PURE__*/_jsx("h1", {
        className: "".concat(config === null || config === void 0 || (_config$projects = config.projects) === null || _config$projects === void 0 || (_config$projects = _config$projects.moduleConfig) === null || _config$projects === void 0 ? void 0 : _config$projects.fontBody),
        children: "No cities found!"
      })
    })]
  });
};
export default CityList;